import {DealList, QueryDealsArgs} from "@irati/types"
import {createUseQuery} from "@irati/utils/services/apollo"

import dealsQuery, {dealListQueryKey} from "./services/queries/dealList"
import blackListedCategoriesForBrandsQuery, {blackListedCategoriesForBrandsKey} from "./services/blackListedCategoriesForBrands"
import dealsErrorHandler from "./services/errors/dealsErrorHandler"

export const useDealList = createUseQuery<DealList, QueryDealsArgs>(dealsQuery, {
  key: dealListQueryKey,
  errorHandlers: [dealsErrorHandler]
})
export const useBlackListedCategories = createUseQuery<string[], {}>(blackListedCategoriesForBrandsQuery, {
  key: blackListedCategoriesForBrandsKey
})
